const DISPLAY_NSFW_COOKIE = 'n_display_nsfw'
/** ~1 year */
const COOKIE_MAX_AGE_SEC = 60 * 60 * 24 * 365

function readCookie(name: string): string | null {
  if (typeof document === 'undefined') return null
  const prefix = `${name}=`
  for (const part of document.cookie.split(';')) {
    const trimmed = part.trim()
    if (trimmed.startsWith(prefix)) {
      return decodeURIComponent(trimmed.slice(prefix.length))
    }
  }
  return null
}

function writeCookie(name: string, value: string) {
  if (typeof document === 'undefined') return
  document.cookie = [
    `${name}=${encodeURIComponent(value)}`,
    `Path=/`,
    `Max-Age=${COOKIE_MAX_AGE_SEC}`,
    `SameSite=Lax`,
  ].join('; ')
}

function readDisplayNsfwCookie(): boolean {
  return readCookie(DISPLAY_NSFW_COOKIE) === '1'
}

function writeDisplayNsfwCookie(enabled: boolean) {
  writeCookie(DISPLAY_NSFW_COOKIE, enabled ? '1' : '0')
}

/** Client-visible reading preferences (cookie-backed on this device). */
export const prefs = $state({
  displayNsfw: false,
  loaded: false,
})

/** Load display preferences from cookie into memory. */
export function loadPreferences() {
  prefs.displayNsfw = readDisplayNsfwCookie()
  prefs.loaded = true
}

export function setDisplayNsfw(enabled: boolean) {
  prefs.displayNsfw = enabled
  prefs.loaded = true
  writeDisplayNsfwCookie(enabled)
}

/** Re-sync in-memory prefs from cookie (e.g. after logout). */
export function resetPreferences() {
  prefs.displayNsfw = readDisplayNsfwCookie()
  prefs.loaded = true
}

/** Drop adult-marked series when the user has NSFW display disabled. */
export function filterNsfwSeries<T extends { Status?: { isAdult?: boolean } }>(
  list: T[] | null | undefined,
): T[] {
  const series = Array.isArray(list) ? list : []
  if (prefs.displayNsfw) return series
  return series.filter((s) => !s?.Status?.isAdult)
}
